import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { IntegrationsApiService } from '@recruitee/integrations-http';

import { RemoteTemplate } from '../../../types';

@Injectable({ providedIn: 'root' })
export class RemoteTemplateHttpClient {
  constructor(private httpApi: IntegrationsApiService) {}

  public fetch(integrationKind: string): Observable<RemoteTemplate[]> {
    return this.httpApi
      .get(`field-mapping/i/${integrationKind}/remote-templates`)
      .pipe(map(({ templates }: { templates: RemoteTemplate[] }) => templates));
  }
}
